import K from '../constants';
import restHelpers from '../helpers/restHelper';

const supportRequestFn = (subject, message) => restHelpers.withBearer.post(`${K.API_URL}/communications/support-communications`, { data: { subject, message } });

export default {
  supportRequest: supportRequestFn
};
